import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { FailedEmailRow, ResolveFailedEmailInput, RetryFailedEmailInput } from '@pqrs/contracts';
import { apiGet, apiPost } from '@/api/client';
import { useSession } from '@/app/session';

/** Correos al ciudadano que no salieron y siguen pendientes (de los casos que la persona ve). */
export const failedEmailKeys = { all: ['emails', 'failed'] as const, count: ['emails', 'failed', 'count'] as const };

/** Solo con «Ver correos no enviados»: el contador del menú y el aviso de arriba. */
export function useFailedEmailCount() {
  const { me, can } = useSession();
  return useQuery({ queryKey: failedEmailKeys.count, queryFn: () => apiGet<{ count: number }>('/communications/failed/count'), refetchInterval: 60_000, enabled: !!me && me.operation === 'LIVE' && can('emails.failed') });
}
export const useFailedEmails = (enabled = true) => useQuery({ queryKey: failedEmailKeys.all, queryFn: () => apiGet<FailedEmailRow[]>('/communications/failed'), enabled });

/** Tras reenviar o resolver: la lista, el contador del aviso y lo del expediente (cabecera, comunicaciones). */
function useInvalidate() {
  const qc = useQueryClient();
  return () => { void qc.invalidateQueries({ queryKey: ['emails'] }); void qc.invalidateQueries({ queryKey: ['cases'] }); };
}
/** Sin `to`, a la misma dirección; con `to`, a otro correo (el del ciudadano no cambia). */
export function useRetryEmail() {
  const done = useInvalidate();
  return useMutation({ mutationFn: ({ id, ...b }: RetryFailedEmailInput & { id: string }) => apiPost<{ status: string }>(`/communications/${id}/retry`, b), onSettled: done });
}
export function useResolveEmail() {
  const done = useInvalidate();
  return useMutation({ mutationFn: ({ id, ...b }: ResolveFailedEmailInput & { id: string }) => apiPost(`/communications/${id}/resolve`, b), onSuccess: done });
}
